var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileAudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20.096,5.389l-3.484-3.485c-1.229-1.228-2.861-1.904-4.597-1.904h-5.515C4.019,0,2,2.019,2,4.5v15c0,2.481,2.019,4.5,4.5,4.5h11c2.481,0,4.5-2.019,4.5-4.5v-9.515c0-1.737-.677-3.369-1.904-4.596Zm-.707.707c.551.551.971,1.198,1.244,1.904h-5.132c-.827,0-1.5-.673-1.5-1.5V1.368c.705.273,1.353.692,1.904,1.243l3.484,3.485Zm1.611,13.404c0,1.93-1.57,3.5-3.5,3.5H6.5c-1.93,0-3.5-1.57-3.5-3.5V4.5c0-1.93,1.57-3.5,3.5-3.5h5.515c.334,0,.663.03.985.088v5.412c0,1.378,1.121,2.5,2.5,2.5h5.412c.058.322.088.651.088.985v9.515Zm-7.5-9c-1.895,0-3.695,1.885-4.232,2.5h-.268c-1.103,0-2,.897-2,2v1c0,1.103.897,2,2,2h.268c.537.615,2.338,2.5,4.232,2.5.276,0,.5-.224.5-.5v-9c0-.276-.224-.5-.5-.5Zm-.5,8.941c-1.572-.359-3.093-2.232-3.109-2.253-.096-.118-.239-.188-.391-.188h-.5c-.552,0-1-.449-1-1v-1c0-.551.448-1,1-1h.5c.151,0,.295-.069.391-.188.017-.021,1.537-1.895,3.109-2.253v7.882Zm4.5-3.941c0,1.141-.771,2.137-1.875,2.421-.042.011-.084.016-.125.016-.223,0-.426-.15-.484-.375-.068-.267.092-.54.359-.609.662-.17,1.125-.768,1.125-1.453s-.463-1.282-1.125-1.453c-.268-.069-.428-.342-.359-.609.069-.268.34-.429.609-.36,1.104.285,1.875,1.28,1.875,2.421Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileAudio);
export default __webpack_public_path__ + "static/media/file-audio.ed355d3c24d9fe24351da6e70f499467.svg";
export { ForwardRef as ReactComponent };